(function () {
    'use strict';

    let module = angular.module('uwAgenda.ringfoon');
    module.factory('Daytask', ['TaskStateEnum', 'FlagTypeEnum', DaytaskFactoryFn]);

    // daytask model
    function DaytaskFactoryFn(TaskStateEnum, FlagTypeEnum) {
        let Daytask = function () {            
            this.vmId = Math.random();
        };

        // extend object
        Daytask.prototype.extend = function (object) {
            let self = this;
            angular.extend(self, object);

            // flag colors
            if (self.flag !== null) {
                angular.forEach(FlagTypeEnum, function (flag) {
                    if (flag.value === self.flag) {
                        self.taskFlag = flag;                        
                    }
                });
            }
            
            for (const element of self.reactions) {
                if (element.reactionByRingphone) {
                    element.vmUserColor = 'font-red-soft';
                } else {
                    element.vmUserColor = 'font-blue-soft'; 
                }
            }
        };

        return Daytask;

    }
})();